<script lang="ts" setup>
import type { NuxtError } from "#app";
import * as Sentry from "@sentry/nuxt";

const props = defineProps<{
  error: NuxtError;
}>();

const AVAILABLE_ERRORS = [404];
const { t } = useI18n();
const statusCode = props.error.statusCode ?? 500;
const statusMessage = props.error.statusMessage ?? "";

if (!AVAILABLE_ERRORS.includes(statusCode)) {
  Sentry.captureException(props.error, {
    extra: {
      statusCode,
      statusMessage
    }
  });
}
</script>

<template>
  <BackgroundAuth />
  <section class="error-page">
    <DesignSystemCardTemplate>
      <DesignSystemCardHeader>
        <DesignSystemCardTitle>
          {{
            statusCode === 404
              ? t("errors.notFoundTitle")
              : t("errors.genericTitle")
          }}
        </DesignSystemCardTitle>
        <DesignSystemCardSubtitle>
          {{
            statusCode === 404
              ? t("errors.notFoundDescription")
              : t("errors.genericDescription", {
                  statusCode,
                  statusMessage
                })
          }}
        </DesignSystemCardSubtitle>
      </DesignSystemCardHeader>
      <DesignSystemButton
        type="is-primary"
        @click="clearError({ redirect: '/' })"
      >
        {{ t("errors.backHome") }}
      </DesignSystemButton>
    </DesignSystemCardTemplate>
  </section>
</template>

<style lang="scss" scoped>
.error-page {
  @include ds-page-section(560px);
  position: relative;
  z-index: 1;
  min-height: 100dvh;
  padding: $spacing_8 $spacing_4;
  display: flex;
  align-items: center;
}
</style>
